/**
 * Provider adapters — GA4/gtag, GTM dataLayer, safe no-op (Milestone 15).
 */
import { loadGoogleAnalytics, trackGoogleAnalyticsEvent, trackGoogleAnalyticsPageView } from "../clientViewRuntime/utils/googleAnalytics";
import { getGaMeasurementId, getGtmContainerId, isAnalyticsDebugMode, isPublicAnalyticsEnabled } from "./analyticsConfig";
import { sanitizeAnalyticsPayload } from "./sanitize";

let gaBootstrapped = false;

function ensureGaLoaded() {
  const measurementId = getGaMeasurementId();
  if (!measurementId || gaBootstrapped) return measurementId;
  loadGoogleAnalytics(measurementId);
  gaBootstrapped = true;
  return measurementId;
}

function ensureDataLayer() {
  if (typeof window === "undefined") return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function dispatchGtag(eventName, payload = {}) {
  const measurementId = ensureGaLoaded();
  if (!measurementId || typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  if (eventName === "page_view") {
    trackGoogleAnalyticsPageView(measurementId, payload.pagePath || payload.path || window.location.pathname);
    return;
  }

  trackGoogleAnalyticsEvent(eventName, payload, payload);
}

function dispatchGtm(eventName, payload = {}) {
  const containerId = getGtmContainerId();
  if (!containerId) return;

  const dataLayer = ensureDataLayer();
  if (!dataLayer) return;

  dataLayer.push({
    event: eventName,
    automapEvent: true,
    ...payload,
  });
}

function dispatchMidpointBridge(eventName, payload = {}) {
  if (typeof window !== "undefined" && typeof window.__midpointTrack === "function") {
    window.__midpointTrack(eventName, { domain: "automap_analytics", ...payload });
  }
}

export function dispatchAnalyticsProviders(eventName, payload = {}) {
  if (!eventName) return;

  try {
    if (!isPublicAnalyticsEnabled()) {
      if (isAnalyticsDebugMode()) {
        // eslint-disable-next-line no-console
        console.debug("[analytics-disabled]", eventName, payload);
      }
      return;
    }

    const clean = sanitizeAnalyticsPayload(payload);
    dispatchGtag(eventName, clean);
    dispatchGtm(eventName, clean);
    dispatchMidpointBridge(eventName, clean);

    if (isAnalyticsDebugMode()) {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", eventName, clean);
    }
  } catch {
    // Never break buyer flows.
  }
}
